import * as React from 'react';
import styled from 'styled-components';
import MotifInlineMessage from '@ey/motif-react-wrapper/InlineMessage';

interface ErrorMessageProps {
    message: string
}

const ErrorMessage = (props:ErrorMessageProps) => {
    return (
        <StyledErrorMessage>
             <MotifInlineMessage variant="error" className="inline-message">
                {props.message}
            </MotifInlineMessage>
        </StyledErrorMessage>
    )
}

export default ErrorMessage

const StyledErrorMessage = styled.section`
      display: flex;
      align-items: center;
      .inline-message {
        width: 100%;
        span {
            min-width: 6%;
        }
      }   
     
`